import WelcomeComponent from './welcome.vue'
export default WelcomeComponent
